import $rdf from '@zazuko/env/web.js';
import { sh } from '@tpluscode/rdf-ns-builders';
import { TRUE } from '../../lib/rdf.js';
import { constraintComponents } from './index.js';
export default function (shape, factory) {
    const shapeModel = buildParameterModel(shape);
    return [...constraintComponents].flatMap(([, component]) => {
        return [...component.fromShape(shapeModel, factory)];
    });
}
function buildParameterModel(shape) {
    return [...shape.dataset.match(shape.term)]
        .reduce((previousValue, { predicate }) => {
        const values = shape.out(predicate).toArray()
            .reduce((previous, pointer) => {
            if (pointer.isList()) {
                return [...previous, { list: [...pointer.list()].filter(isActive) }];
            }
            if (isActive(pointer)) {
                return [...previous, { pointer }];
            }
            return previous;
        }, []);
        return previousValue.set(predicate, values);
    }, $rdf.termMap());
}
function isActive(ptr) {
    return !TRUE.equals(ptr.out(sh.deactivated).term);
}
